export default class ValueAndPlayerId {
    public value: boolean = false;
    public playerId: string = null;
}